import React from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import Chatbot from '../components/Chatbot';
import { Outlet } from 'react-router-dom';

const MainLayout = () => {
  return (
    <div className='p-3'>
      <Header />
      <Outlet />
      <Footer />
      <Chatbot />
    </div>
  );
};

export default MainLayout;
